import { useMemo } from 'react';
import { object, string } from 'yup';

export function useNameSchema() {
    return useMemo(
        () =>
            object().shape({
                name: string().required(),
            }),
        [],
    );
}
